/**
 * Convertes a file to base64
 *
 * @param {File} file
 * @returns {Promise<string|ArrayBuffer>}
 */
export const fileToBase64 = (file: File): Promise<string | ArrayBuffer> => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result!)
  })
}

/**
 * Triggers a browser download for the given file contents
 *
 * @param {BlobPart} content
 * @param {string} filename
 * @param {string} type
 */
export const downloadFile = (content: BlobPart, filename: string, type: string) => {
  const url = window.URL.createObjectURL(new Blob([content], { type }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  window.URL.revokeObjectURL(url)
}
